import axios from "axios";

const URL = 'https://api.vimeo.com/me/videos/';
export default {
  namespaced: true,

  state: {},
  actions: {
    GET_VIDEOLINK: function ({commit}, id) {
      let url = URL + id;
      return axios.get(url, {
        headers: {
          Authorization: 'Bearer 03b8b27294f0bf7a7d8f961c3c01c723',
          Accept: 'application/vnd.vimeo.*+json;version=3.4',
          'Content-Type': 'application/json'
        }
      })
    },
  },
  mutations: {},
  getters: {}
}
